import React from 'react';
import cx from "classnames";
import PropTypes from "prop-types"
import {Switch} from 'antd';

const NewCheckbox = ({className, label, position, checked, field, form, ...props}) => {

    const classes = cx(
        'new-checkbox-form',
        checked && 'is-active',
        className
    );

    const handleChange = (checked) => {
        form.setFieldValue(field.name, checked);
    };

    return (
        <div className={classes}>
            <label className="form-field__checkbox">
                {label && (
                    <div className={`form-field__label ${field.value && 'is-active'}`}>{label}</div>
                )}
                <Switch
                    {...props}
                    checked={field.value}
                    onChange={handleChange}
                    className={'custom-ant-switch'}
                />
            </label>

        </div>
    );
};

NewCheckbox.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    position: PropTypes.oneOf(["left", "beet"]),
};

NewCheckbox.defaultProps = {
    className: null,
    label: null,
    position: 'beet'
};

export default NewCheckbox;
